import * as React from 'react';
import * as vars from '../consts/variables';
import { PhoneIcon } from './Icons/PhoneIcon';
import { Link } from './Link';

const styles: Record<string, React.CSSProperties> = {
    advisorWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '7px 15px',
        background: vars.lightGray,
        position: 'relative',
    },
    advisorFigure: {
        width: 65,
        height: 65,
        boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.21)',
        flex: '0 0 auto',
        margin: '0 11px 0 0',
        borderRadius: '50%',
        position: 'relative',
    },
    advisorDetails: {
        flex: '1 1 auto',
    },
    advisorName: {
        margin: '4px 0',
        fontSize: 17,
        fontWeight: 'bold',
        color: vars.black,
        width: '100%',
        display: 'block',
    },
    advisorPhoneNumber: {
        fontSize: 15,
        color: vars.black,
        display: 'inline-block',
        verticalAlign: 'middle',
    },
    advisorDescription: {
        fontSize: 15,
        lineHeight: 1.3,
        marginTop: 15,
    },
    arrowDown: {
        position: 'absolute',
        top: '100%',
        background: vars.lightGray,
        left: 35,
        width: 25,
        height: 25,
        marginTop: -14,
        transform: 'rotate(30deg) skew(-30deg)',
    },
    phoneIcon: {
        fill: vars.black,
        marginRight: 5,
        display: 'inline-block',
        verticalAlign: 'middle',
    },
    wrapper: {
        marginTop: 10,
    },
};

interface IProps {
    headline: string;
    text: string;
    name: string;
    image: string;
    phone: string;
}

export function AdvisorTipps(props: IProps) {
    const imagePath =
        props.image ||
        'https://images.dreamlines.de/wp-content/uploads/20180116202434/Jeanet_Schreiter.gif';
    const advisorImage: any = {
        ...styles.advisorFigure,
        background: `url('${imagePath}') center top no-repeat`,
        backgroundSize: '65px auto',
    };
    return (
        <div>
            <Link style={styles.advisorWrapper} href={`tel:${props.phone?.replace(/\s*/g, '')}`}>
                <div className="arrow" style={styles.arrowDown}></div>
                <figure style={advisorImage} />
                <div style={styles.advisorDetails}>
                    {props.name && <span style={styles.advisorName}>{props.name}</span>}
                    <PhoneIcon style={styles.phoneIcon} />
                    <span style={styles.advisorPhoneNumber}>{props.phone?.trim()}</span>
                </div>
            </Link>

            <div
                className="advisorDescription"
                style={styles.advisorDescription}
                dangerouslySetInnerHTML={{ __html: props.text }}
            />
        </div>
    );
}
